import { GoogleAuthProvider, signInWithPopup,verifyPasswordResetCode,confirmPasswordReset, signInWithCredential,createUserWithEmailAndPassword,signInWithEmailAndPassword,RecaptchaVerifier,signInWithPhoneNumber,linkWithPhoneNumber,linkWithCredential,PhoneAuthProvider,sendPasswordResetEmail} from "firebase/auth";
import { auth } from "../utils/fcm";
import { useEffect, useState } from "react";
import { useFormHandling } from "./formUtils";
import { RequestConfigs } from "../api";
import { set } from "date-fns";
import { useLoader } from "../contexts/LoaderContext";
import { useDictionary } from "../contexts/dictionary";
import { useNavigate } from "react-router-dom";
import { useContactType } from "../contexts/ContactContext";

const firebaseErrorMessages: Record<string, string> = {
    "auth/email-already-in-use": 'email_exists',
    "auth/invalid-email": 'invalid_email',
    "auth/user-not-found": 'user_not_found',
    "auth/wrong-password": 'wrong_password',
    "auth/too-many-requests": 'too_many_requests',
    "auth/network-request-failed": 'network_request_failed',
    "auth/requires-recent-login": 'requires_recent_login',
    "auth/weak-password": 'weak_password',
    "auth/missing-phone-number": 'missing_phone_number',
    "auth/quota-exceeded": 'quota_exceeded',
    "auth/missing-verification-code": 'missing_verification_code',
    "auth/invalid-verification-code":  'invalid_verification_code',
    "auth/invalid-phone-number": 'invalid_phone_number',
    "auth/captcha-check-failed": 'captcha_check_failed',
    "auth/session-expired": 'session_expired',
    "auth/internal-error": 'internal_error',
    "auth/account-exists-with-different-credential": 'account_exists_with_different_credential',
    "auth/invalid-credential": 'invalid_credential',
};

const formatPhoneNumber = (phone: string): string => {
    if (phone.length > 0 && phone[0] === '0') {
      return `+972${phone.slice(1)}`;
    }
    return phone;
  };


export const ensureRecaptcha = (authInstance: any, containerId: string = 'recaptcha-container') => {
    let container = document.getElementById(containerId);

    // If container exists, remove and recreate it to fully reset the widget
    if (container) {
        container.remove();
    }

    // Recreate a fresh container
    const newContainer = document.createElement("div");
    newContainer.id = containerId;
    document.body.appendChild(newContainer); // or append it to a specific container in your UI

    // Clear any previous verifier instance
    if (window.recaptchaVerifier) {
        try {
            window.recaptchaVerifier.clear();
        } catch (err) {
            console.warn("Failed to clear previous reCAPTCHA", err);
        }
        window.recaptchaVerifier = undefined;
    }

    // Create a new verifier
    window.recaptchaVerifier = new RecaptchaVerifier(authInstance, containerId, {
        size: "invisible",
        callback: (response: any) => {
            console.log("reCAPTCHA solved:", response);
        },
        "expired-callback": () => {
            console.warn("reCAPTCHA expired");
            window.recaptchaVerifier?.clear();
            window.recaptchaVerifier = undefined;
        },
    });
};

export const getFirebaseErrorMessage = (errorCode: string): string => {
    if(firebaseErrorMessages[errorCode]){
        return firebaseErrorMessages[errorCode]
    } else {
        console.log("Unknown error code:", errorCode);
        return "An unexpected error occurred. Please try again.";
    }
    
};

export const GoogleLoginNew = () => {

    const {translate} = useDictionary();
    const {setLoading} = useLoader();   
    const provider = new GoogleAuthProvider();



    const processGoogleAuth = async () => {
        try {
            const result = await signInWithPopup(auth, provider)
            const user = result.user;
            const data = {
                Full_Name: user.displayName,
                Email: user.email,
                Record_Image: user.photoURL,
                Firebase_Id: user.uid,
                Allowed_Terms: true,
            }
           return { message: "success", succeeded: true,data }
            

        } catch (error: any) {
            console.log(error, "registration error");
            const errorMessage = getFirebaseErrorMessage(error.code);
            return { message: translate(errorMessage), succeeded: false }
        }
    }


    return { processGoogleAuth }

};

export const EmailPasswordAuthNew = () => {
    const {translate} = useDictionary();
    const {setLoading} = useLoader();

 

    const registerUser = async (email: string, password: string) => {
        setLoading(true);
        try {
            console.log("Registering user with email and password", email, password);
            const emailCredential = await createUserWithEmailAndPassword(auth, email, password);
            const user = emailCredential.user;
            const data = {
                Firebase_Id: user.uid,
                Email: email,
            }
             setLoading(false);
            return { message: "success", succeeded: true,data }
        
    

         
        } catch (error: any) {
            console.log(error, "registration error");
            const errorMessage = getFirebaseErrorMessage(error.code);
            setLoading(false);
            return { message: translate(errorMessage), succeeded: false }
        }
    };
    
    

   

    const loginUserWithPassword = async (email: string, password: string) => {
        setLoading(true);
        console.log('loginUserWithPassword')
        try {
            const emailCredential = await signInWithEmailAndPassword(auth, email, password);
            const user = emailCredential.user;

            const data = {
                Firebase_Id: user.uid,
                Email: email,
            }
            
            console.log("User logged in", user);
            setLoading(false);
            return { message: "success", succeeded: true,data }
        } catch (error:any) {
            const errorMessage = getFirebaseErrorMessage(error.code);
            setLoading(false);
            return { message: translate(errorMessage), succeeded: false }
    
        }
    };

    const resetPassword = async (email: string) => {
        setLoading(true);
        try {
            await sendPasswordResetEmail(auth, email,{
                url: `${process.env.REACT_APP_API_ENDPOINT}/reset-password?email=${encodeURIComponent(email)}`
              });
            setLoading(false);
            return { message: translate('reset_link_sent'), succeeded: true };
        } catch (error: any) {
            const errorMessage = getFirebaseErrorMessage(error.code);
            setLoading(false);
            return { message: translate(errorMessage), succeeded: false };
        }
    };

    const resetAndLogin = async (email: string, oobCode: string, newPassword: string) => {
        try {
          await confirmPasswordReset(auth, oobCode, newPassword);
      
          // Step 2: Immediately sign them in
          const userCredential = await signInWithEmailAndPassword(auth, email, newPassword);
          const user = userCredential.user;

          const data = {
              Firebase_Id: user.uid,
              Email: email,
          }

          return { succeeded: true,data };
        } catch (error: any) {
          const errorMessage = getFirebaseErrorMessage(error.code);
          return { succeeded: false, message: errorMessage };
        }
      };

    return { loginUserWithPassword,registerUser,resetPassword,resetAndLogin };
};


export const PhoneAuthNew = ()=>{

    const {translate} = useDictionary();
    const {setLoading} = useLoader();



    const verifyPhoneAndLink = async (verificationId:string, otp: string) => {
       
    
        setLoading(true);
        try {
            const phoneCredential = PhoneAuthProvider.credential(verificationId, otp);
            if (!auth.currentUser) {
                throw new Error("No authenticated user found");
            }
            console.log("Linking phone number to user", auth.currentUser.uid,phoneCredential);
            const link = await linkWithCredential(auth.currentUser, phoneCredential);
            console.log("Linking phone done", auth.currentUser.uid);
            setLoading(false);
            return { message: "success", succeeded: true,data:link }
       
        } catch (error:any) {
            const errorMessage = getFirebaseErrorMessage(error.code);
            setLoading(false);
            return { message:translate(errorMessage), succeeded:false}
        }
    };

    const addPhoneAuth = async (phone: string) => {
        phone = formatPhoneNumber(phone);
        const recaptchaContainer = 'recaptcha-container';
        setLoading(true);
        try {
            ensureRecaptcha(auth, recaptchaContainer); // ✅ NEW LINE
    
            console.log("Starting phone verification...");
            const confirmationResult = await signInWithPhoneNumber(auth, phone, window.recaptchaVerifier);
    
            console.log("OTP sent to", phone);
            setLoading(false);
            return { message: 'success', succeeded: true, verificationId: confirmationResult.verificationId }
            
        } catch (error: any) {
            console.log(error, "registration error");
            const errorMessage = getFirebaseErrorMessage(error.code);
            setLoading(false);
            return { message: translate(errorMessage), succeeded: false }
            
        }
    };

    return {verifyPhoneAndLink,addPhoneAuth}

}


export const OtpAuth = () => {
    const {translate} = useDictionary();
    const {setLoading} = useLoader();

    
    const loginWithOtp = async (verificationId: string, otp: string) => {
        setLoading(true);
        try {
            const phoneCredential = PhoneAuthProvider.credential(verificationId, otp);
            if (!auth.currentUser) {
                throw new Error("No authenticated user found");
            }
            console.log("login user with otp", auth.currentUser.uid,phoneCredential);
            const userCredential = await signInWithCredential(auth, phoneCredential);
            
            console.log("verify phone done", auth.currentUser.uid);
            setLoading(false);
            return { message: "success", succeeded: true,data:userCredential }
       
        } catch (error:any) {
            const errorMessage = getFirebaseErrorMessage(error.code);
            setLoading(false);
            return { message:translate(errorMessage), succeeded:false}
        }
    }

    return { loginWithOtp }

}


